export default __webpack_public_path__ + "static/media/GreenCard.695ce928.svg";